import {inject, Injectable} from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NotificationTemplateActions } from './notification-template.actions';
import { catchError, map, mergeMap, of, switchMap } from 'rxjs';
import {
  NotificationTemplateApiService,
} from '@modules/notifications/notification-template/services/notification-template-api.service';

@Injectable()
export class NotificationTemplateEffects {
  private readonly actions$ = inject(Actions);
  private readonly api = inject(NotificationTemplateApiService);

  /**
   * Load a single notification template by UUID
   * (used for the edit page)
   */
  loadOne$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationTemplateActions.loadOne),
      switchMap(({ uuid }) =>
        this.api.getNotificationTemplateByUuid(uuid).pipe(
          map((entity) =>
            NotificationTemplateActions.loadOneSuccess({ entity })
          ),
          catchError((error) =>
            of(NotificationTemplateActions.loadOneFailure({ error }))
          )
        )
      )
    )
  );

  /**
   * Update an existing notification template
   * Backend only supports updating: uuid, content, displayName
   */
  update$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationTemplateActions.update),
      mergeMap(({ uuid, changes }) =>
        this.api.updateNotificationTemplate(uuid, {
          content: changes.content,
          displayName: changes.displayName,
          fileDto: changes.fileDto,
        }).pipe(
          map((updated) =>
            NotificationTemplateActions.updateSuccess({ entity: updated })
          ),
          catchError((error) =>
            of(NotificationTemplateActions.updateFailure({ error }))
          )
        )
      )
    )
  );
}
